import React from 'react';
import { useTheme } from '../ThemeProvider';

interface MagicContentProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string;
}

export const MagicContent: React.FC<MagicContentProps> = ({
  children,
  className = '',
  maxHeight = 'max-h-80',
}: MagicContentProps) => {
  const { provideTailwind } = useTheme();

  return (
    <div
      className={`flex-1 flex flex-col overflow-hidden px-4 pb-4 ${className}`}
      style={{ paddingTop: '0.25rem' }}
    >
      <div
        className={`flex-1 flex flex-col rounded-4xl shadow-lg relative ${className}`}
        style={{
          background:
            'linear-gradient(to right, #DB1667 0%, #DB1667 17%, rgba(9, 0, 255, 0.43) 100%)',
          padding: '2px',
        }}
      >
        <div
          className={`${provideTailwind(
            'bg-primary',
          )} rounded-4xl p-4 w-full h-full flex flex-col`}
        >
          {/* Scrollable Content Area - handles all scrolling at container level */}
          <div
            className={`flex-1 ${maxHeight} overflow-y-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-400/30 scrollbar-thumb-rounded hover:scrollbar-thumb-gray-400/50 pr-1`}
          >
            {children}
            {/* Spacer div to ensure content doesn't touch the bottom */}
            <div className="h-4 pb-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
